<!-- Global Alerts Layout (Error & Success Floating Notifications Container) -->
<div class="position-fixed top-0 end-0 p-3 z-3 d-flex flex-column gap-2" style="max-width: 350px">
  @if (errorMessage()) {
  <div
    class="alert alert-danger alert-dismissible shadow border-danger border-opacity-25 fade show d-flex align-items-center gap-2 m-0 font-monospace py-2.5"
    role="alert">
    <i class="bi bi-exclamation-triangle-fill flex-shrink-0 text-danger fs-5"></i>
    <div class="small lh-sm flex-grow-1 pe-2">
      <strong>Execution Error:</strong> {{ errorMessage() }}
    </div>
    <button type="button" class="btn-close shadow-none top-50 translate-middle-y my-0 end-0 me-2"
      aria-label="Close"></button>
  </div>
  } @if (successMessage()) {
  <div
    class="alert alert-success alert-dismissible shadow border-success border-opacity-25 fade show d-flex align-items-center gap-2 m-0 font-monospace py-2.5"
    role="alert">
    <i class="bi bi-check-circle-fill flex-shrink-0 text-success fs-5"></i>
    <div class="small lh-sm flex-grow-1 pe-2">{{ successMessage() }}</div>
    <button type="button" class="btn-close shadow-none top-50 translate-middle-y my-0 end-0 me-2"
      aria-label="Close"></button>
  </div>
  }
</div>

<div class="container mt-3">
  <div class="card shadow-sm border-0 mb-3 bg-body rounded-3 overflow-hidden">
    <!-- Top Background Border Strip (Changes flavor based on status) -->
    <div class="py-1" [ngClass]="{
    'bg-success': surveyInfoData().status === 'ACTIVE',
    'bg-primary': surveyInfoData().status === 'OPEN',
    'bg-secondary': surveyInfoData().status === 'CLOSED'
  }"></div>

    <div class="card-body p-4">
      <div class="d-flex flex-column flex-md-row justify-content-between align-md-items-center gap-3">
        <!-- LEFT SIDE: BACK NAVIGATION + SURVEY LOG DETAILS -->
        <div class="d-flex align-items-start gap-3">
          <!-- Bulletproof Back Button Navigation Node Link Wrapper -->
          <button type="button"
            class="btn btn-outline-secondary border-0 p-2 rounded-circle shadow-none hover-bg-light transition-base"
            title="Back to Survey Management List Framework Layer Panel" (click)="goBack()">
            <i class="bi bi-arrow-left fs-4 line-height-none d-block"></i>
          </button>

          <div>
            <!-- TITLE AND STATUS COUNTER MATCH PILL BLOCK -->
            <div class="d-flex flex-wrap align-items-center gap-2 mb-1.5">
              <h2 class="h4 fw-bold text-body-emphasis m-0 tracking-tight">
                {{ surveyInfoData().name }}
              </h2>

              <span
                class="badge font-monospace px-2.5 py-1.5 rounded-pill border fw-bold text-uppercase tracking-wider small"
                [ngClass]="{
                'bg-success-subtle text-success-emphasis border-success-subtle': surveyInfoData().status === 'ACTIVE',
                'bg-primary-subtle text-primary-emphasis border-primary-subtle': surveyInfoData().status === 'OPEN',
                'bg-secondary-subtle text-secondary-emphasis border-secondary-subtle': surveyInfoData().status === 'CLOSED'
              }">
                <i class="bi bi-circle-fill me-1 small opacity-75"></i> {{
                surveyInfoData().status }}
              </span>
            </div>

            <!-- METADATA INFORMATION ROW SUMMARY STRIP LINKS -->
            <div class="d-flex flex-wrap align-items-center gap-x-3 gap-y-1 text-body-secondary small">
              <span class="d-inline-flex align-items-center gap-1">
                <i class="bi bi-calendar-event text-primary opacity-75"></i>
                <strong>Start:</strong> {{ surveyInfoData().startDate | date:
                'dd MMM yyyy' }}
              </span>
              <span class="text-muted d-none d-sm-inline opacity-50">|</span>
              <span class="d-inline-flex align-items-center gap-1">
                <i class="bi bi-calendar-check text-danger opacity-75"></i>
                <strong>End:</strong> {{ surveyInfoData().endDate | date: 'dd
                MMM yyyy' }}
              </span>
              <span class="text-muted d-none d-sm-inline opacity-50">|</span>
              <span class="d-inline-flex align-items-center gap-1">
                <i class="bi bi-hourglass-split text-warning opacity-75"></i>
                <strong>Period:</strong> {{ surveyInfoData().period }}
              </span>
            </div>
          </div>
        </div>

        <!-- RIGHT SIDE: ACTIVE CTAs OR CONTEXT DROPDOWNS -->
        <!-- <div class="d-flex align-items-center gap-2 self-start md-self-center ms-5 ms-md-0">
        <button type="button" class="btn btn-sm btn-light border shadow-sm px-3 py-2 text-body" (click)="refreshSurveyData()">
          <i class="bi bi-arrow-clockwise me-1"></i> Refresh
        </button>
      </div> -->
      </div>
    </div>
  </div>

  <div class="bg-light p-3 mb-3 rounded-3 border border-light-subtle flex-grow-1 flex-xl-grow-0">
    <div class="text-uppercase font-monospace text-body-secondary small fw-bold tracking-wider mb-2">
      <i class="bi bi-bookmark-star-fill text-warning me-1"></i> Scoring Metric Scales Guide
    </div>

    <div class="table-responsive m-0">
      <table class="table table-sm table-borderless align-middle mb-0 small font-monospace text-nowrap">
        <thead>
          <tr class="text-body-secondary border-bottom border-light-subtle">
            @for (r of ratings(); track r.ratingId) {
            <th class="fw-semibold px-2 pb-1 text-center">
              {{ r.label }}
            </th>
            }
          </tr>
        </thead>
        <tbody>
          <tr>
            @for (r of ratings(); track r.ratingId) {
            <td class="text-center pt-1 px-2">
              <span class="badge rounded-pill px-2 py-1 fw-bold" [ngClass]="{
                        'bg-success text-white': r.score >= 12,
                        'bg-warning text-dark': r.score === 9,
                        'bg-danger text-white': r.score < 9
                      }">
                Score: {{ r.score }}
              </span>
            </td>
            }
          </tr>
        </tbody>
      </table>
    </div>
  </div>


  @if (isSuperAdminAndAdmin() && isFormStatusOpen()) {
  <div class="d-inline-block transition-base">
    @if (!isAddingSection()) {
    <!-- Standard Button Mode -->
    <button type="button"
      class="btn btn-sm btn-outline-primary fw-medium px-3 py-1.5 d-inline-flex align-items-center gap-1.5 shadow-sm rounded-2 btn-hover-transform"
      (click)="startAddingSection()">
      <i class="fa-solid fa-plus fs-7"></i>
      <span>Add Section Title</span>
    </button>
    } @else {
    <!-- Premium Inline Editor Mode -->
    <div
      class="d-flex align-items-center gap-2 bg-body-tertiary p-1.5 border border-secondary-subtle rounded-3 shadow-sm"
      style="min-width: 320px">
      <div class="position-relative flex-grow-1">
        <div
          class="position-absolute top-50 start-0 translate-middle-y ps-2.5 text-body-secondary opacity-75 pointer-events-none small">
          <i class="fa-solid fa-heading"></i>
        </div>
        <input type="text" #sectionTitleInput
          class="form-control form-control-sm ps-5 bg-body text-body-emphasis border-0 shadow-none focus-none"
          placeholder="Enter new section title..." [(ngModel)]="newSectionTitle" (keyup.enter)="submitSectionTitle()"
          (keyup.escape)="cancelAddingSection()" autocomplete="off" />
      </div>

      <!-- Action Control Buttons -->
      <div class="d-flex gap-1 flex-shrink-0">
        <button type="button"
          class="btn btn-sm btn-primary d-flex align-items-center justify-content-center p-1.5 rounded-2"
          style="width: 28px; height: 28px" [disabled]="!newSectionTitle().trim() || apiLoading()"
          (click)="submitSectionTitle()">
          @if (apiLoading()) {
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          } @else {
          <i class="fa-solid fa-check fs-7"></i>
          }
        </button>
        <button type="button"
          class="btn btn-sm btn-outline-secondary d-flex align-items-center justify-content-center p-1.5 rounded-2 text-body-secondary border-0"
          style="width: 28px; height: 28px" [disabled]="apiLoading()" (click)="cancelAddingSection()">
          <i class="fa-solid fa-xmark fs-7"></i>
        </button>
      </div>
    </div>
    }
  </div>
  } @for (group of groupedSections(); track group.id) {

  <!-- HEADER ROW -->
  <div class="d-flex align-items-center w-100 mb-2">

    <!-- LEFT COLUMN (1/3 Width): Balanced empty spacing block to hold left alignment alignment bounds -->
    <div class="col-4 d-none d-md-block"></div>

    <!-- CENTER COLUMN (1/3 Width): Centers text natively while letting elements grow inline -->
    <div class="col-12 col-md-4 d-flex justify-content-center align-items-center gap-2 text-center">
      @if (editingGroupId() === group.id) {
      <!-- Inline Editing Mode Input Layout Row -->
      <div class="d-flex align-items-center gap-2 justify-content-center w-100">
        <input type="text"
          class="form-control form-control-sm bg-body text-body-emphasis border-primary shadow-sm fw-bold text-primary focus-ring text-center"
          style="
          --bs-focus-ring-color: rgba(var(--bs-primary-rgb), 0.25);
          font-size: 1.25rem;
          max-width: 260px;
        " [(ngModel)]="group.title" (keyup.enter)="submitGroupTitleUpdate(group)"
          (keyup.escape)="cancelGroupTitleEdit()" autocomplete="off" />

        <button type="button" class="btn btn-sm btn-success px-2 py-1" (click)="submitGroupTitleUpdate(group)"
          [disabled]="apiLoading()">
          <i class="fa-solid fa-check"></i>
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary px-2 py-1" (click)="cancelGroupTitleEdit()"
          [disabled]="apiLoading()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      } @else {
      <!-- Standard Static Text Mode View Layer (Perfectly Centered Inline Setups) -->
      <h4 class="fw-bold text-primary m-0 text-center text-break">{{ group.title }}</h4>

      <!-- Update Action Link placed inline right next to the title text -->
      @if (isSuperAdminAndAdmin() && isFormStatusOpen()) {
      <button type="button"
        class="btn btn-sm btn-outline-secondary border-0 p-1 rounded-2 text-body-secondary line-height-none flex-shrink-0"
        title="Update Group Title" (click)="startGroupTitleEdit(group)">
        <i class="bi bi-pencil fs-6"></i>
      </button>
      }
      }
    </div>

    <!-- RIGHT COLUMN (1/3 Width): Dynamic right-side item pinning alignment framework -->
    <div class="col-12 col-md-4 d-flex justify-content-end align-items-center mt-2 mt-md-0">
      @if (isSuperAdminAndAdmin() && isFormStatusOpen() && editingGroupId() !== group.id) {
      <button class="btn btn-sm btn-outline-primary text-nowrap shadow-sm" data-bs-toggle="modal"
        data-bs-target="#createSectionTitleModal" (click)="openCreateSectionModal(group)">
        + Add Section
      </button>
      }
    </div>

  </div>

  @if (!group.sectionInfoRespLst || group.sectionInfoRespLst.length === 0) {
  <div class="text-muted mb-3">No sections available</div>
  }

  <!-- SECTIONS -->
  @for (section of group.sectionInfoRespLst; track section.sectionId) {

  <!-- CARD -->
  <div class="card shadow-sm mb-4">
    <!-- CARD HEADER -->
    <div class="card-header d-flex justify-content-between align-items-center">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <!-- LEFT: Title + Description -->
        <div>
          <h6 class="mb-0 fw-semibold">{{ section.subTitle }}</h6>

          @if (section.description?.trim() && section.description !==
          'undefined') {
          <small class="text-muted mt-1 d-block">
            * {{ section.description }}
          </small>
          }
        </div>

        <!-- RIGHT: ACTION BUTTONS -->
        @if (isSuperAdminAndAdmin() && isFormStatusOpen()) {
        <div class="d-flex gap-2 ms-2">
          <!-- UPDATE -->
          <button class="btn btn-sm btn-light border" title="Update Section" (click)="openEditSectionModal(section)"
            data-bs-toggle="modal" data-bs-target="#createSectionTitleModal">
            <i class="bi bi-pencil"></i>
          </button>

          <!-- DELETE -->
          <!-- <button class="btn btn-sm btn-light border text-danger" title="Remove Section" (click)="onDeleteSection(section)">
            <i class="bi bi-trash"></i>
          </button> -->
        </div>
        }
      </div>

      @if (isSuperAdminAndAdmin() && isFormStatusOpen()) {
      <button class="btn btn-sm btn-outline-success" data-bs-toggle="modal" data-bs-target="#createQuestionModal"
        (click)="openCreateQuestionModal(section.sectionId)">
        + Add Question
      </button>
      }
    </div>

    <!-- TABLE -->
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle mb-0">
          <!-- HEADER -->
          <thead class="table-light">
            <tr>
              <th style="width: 40%">Question</th>
              @for (r of ratings(); track r.ratingId) {
              <th>{{ r.label }}</th>
              }
            </tr>
          </thead>

          <!-- BODY -->
          <tbody>
            <!-- FIX: Changed section.sectionInfoRespLst back to section.questionInfoRespLst -->
            @for (q of section.questionInfoRespLst; track q.questionId) {
            <tr>
              <td class="text-start">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <!-- LEFT -->
                  <div>
                    {{ q.questionTextMy }} <br />
                    <small class="text-muted">[{{ q.questionTextEng }}]</small>
                  </div>

                  <!-- RIGHT: ACTION BUTTONS -->
                  @if (isSuperAdminAndAdmin() && isFormStatusOpen()) {
                  <div class="d-flex gap-2">
                    <button class="btn btn-sm btn-outline-primary" data-bs-toggle="modal"
                      data-bs-target="#createQuestionModal" (click)="openEditQuestionModal(q)" title="Update Question">
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-danger" (click)="onDeleteQuestion(q)" title="Remove Question">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                  }
                </div>

                <!-- DYNAMIC REMARK FIELD LAYER -->
                @if (getRatingScore(q.ratingId) < 12) { <div
                  class="mt-2 bg-light p-2 rounded border border-warning transition-base">
                  <label class="form-label small fw-bold text-danger mb-1">
                    Remarks Required / လိုအပ်သော မှတ်ချက်
                    <span class="text-danger">*</span>
                  </label>
                  <textarea class="form-control form-control-sm bg-body text-body-emphasis border-secondary-subtle"
                    rows="2" [(ngModel)]="q.remark" [disabled]="isSurveySubmitted()"
                    placeholder="Please state your reasons for this low rating score here...">
                  </textarea>
      </div>
      }
      </td>

      @for (r of ratings(); track r.ratingId) {
      <td>
        <input type="radio" name="q_{{section.sectionId}}_{{q.questionId}}" [value]="r.ratingId"
          [(ngModel)]="q.ratingId" [disabled]="isSurveySubmitted()" />
      </td>
      }
      </tr>
      } @if (section.questionInfoRespLst?.length === 0) {
      <tr>
        <td [attr.colspan]="ratings.length + 1" class="text-muted py-4">
          No questions available
        </td>
      </tr>
      }
      </tbody>
      </table>
    </div>
  </div>
</div>

} } @if (!isFormStatusOpen()) {
<div>
  <div class="mb-2 fw-semibold">💬 Suggestions</div>

  <textarea class="form-control" rows="3" placeholder="Write your suggestions here..." [(ngModel)]="suggestions"
    [disabled]="isSurveySubmitted()" maxlength="225">
    </textarea>

  <div class="d-flex justify-content-end mt-1">
    <small class="text-muted" [ngClass]="{ 'text-danger': (suggestions().length || 0) > 200 }">
      {{ suggestions().length || 0 }}/225
    </small>
  </div>
</div>
}

<div class="d-flex justify-content-end">
  @if (isSuperAdminAndAdmin() && !isFormStatusActive()) {
  <div class="text-center mt-4">
    <button class="btn btn-success px-4" [disabled]="isBtnLoading()" (click)="activeSurvey()">
      @if (isBtnLoading()) {
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      } @else { Active }
    </button>
  </div>
  } @if (!isSuperAdminAndAdmin() && !isSurveySubmitted() &&
  isFormStatusActive()) {
  <div class="text-center mt-4">
    <button class="btn btn-success px-4" [disabled]="isBtnLoading()" (click)="submitSurvey()">
      @if (isBtnLoading()) {
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      } @else { Submit }
    </button>
  </div>
  }
</div>
</div>

<!-- Create Survey Section Title Modal -->
<div class="modal fade" id="createSectionTitleModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-3">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
          {{ isEditSectionMode() ? 'Update Section Title' : 'Create Section
          Title' }}
        </h5>
        <button class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body">
        @if (!isEditSectionMode()) {
        <label class="form-label">Title</label>
        <input type="text" class="form-control mb-2" [(ngModel)]="sectionTitle" disabled />
        }
        <label class="form-label">Sub Title</label>
        <input type="text" class="form-control mb-2" [(ngModel)]="subTitle" />

        <label class="form-label">Description</label>
        <input type="text" class="form-control mb-2" [(ngModel)]="description" />
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" data-bs-dismiss="modal">
          Cancel
        </button>
        <button class="btn btn-primary" [disabled]="isSectionLoading()" (click)="createTitle()">
          @if (!isSectionLoading()) { {{ isEditSectionMode() ? 'Update' : 'Save'
          }} } @else {
          <span class="spinner-border spinner-border-sm me-1"></span>
          }
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Create Survey Question Modal -->
<div class="modal fade" id="createQuestionModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-3">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
          {{ isEditQuestionMode() ? 'Update Question' : 'Create Question' }}
        </h5>
        <button class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body">
        <label class="form-label">Question Text MM</label>
        <input type="text" class="form-control mb-2" [(ngModel)]="questionTextMy" />

        <label class="form-label">Question Text ENG</label>
        <input type="text" class="form-control mb-2" [(ngModel)]="questionTextEng" />
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" data-bs-dismiss="modal">
          Cancel
        </button>
        <button class="btn btn-primary" [disabled]="isQuestionLoading()" (click)="createQuestion()">
          @if (!isQuestionLoading()) { {{ isEditQuestionMode() ? 'Update' :
          'Save' }} } @else {
          <span class="spinner-border spinner-border-sm me-1"></span>
          }
        </button>
      </div>
    </div>
  </div>
</div>
